import { ICheckPublishTermSchema } from '../../../../repositories/billing-tariffs/entities/PublishTerms/CheckPublishTermSchema';
import { IAuctionState } from '../../../../types/reducers/auction';
import { ICalltrackingState } from '../../../../types/reducers/calltracking';
import {
  IPublishTermsService,
  IServicePackage,
  IServicePeriod,
  EPlacingType,
} from '../../../../types/reducers/publishTerms';
import { EMoneySource } from '../../../../types/reducers/user';
import { mapAuctionTerm } from './mapAuctionTerm';
import { mapCalltrackingTerm } from './mapCalltrackingTerm';
import { mapPublishTerm } from './mapPublishTerm';

interface IGetPublishTermsParams {
  service: IPublishTermsService | null;
  servicePackage: IServicePackage | null;
  publicationPeriod: IServicePeriod | null;
  placingType: EPlacingType | null;
  auction: IAuctionState;
  isAuctionSelected: boolean;
  calltracking: ICalltrackingState;
  moneySource?: EMoneySource | null;
  increaseToMinimalTopBet: boolean;
  isWithoutServices: boolean;
  minimalBet: number;
  termsDuration: number;
  currentBet: number;
}

export function getPublishTerms(params: IGetPublishTermsParams): ICheckPublishTermSchema[] {
  const {
    service,
    servicePackage,
    publicationPeriod,
    placingType,
    auction,
    isAuctionSelected,
    calltracking,
    increaseToMinimalTopBet,
    isWithoutServices,
    minimalBet,
    termsDuration,
    currentBet,
  } = params;

  const terms: ICheckPublishTermSchema[] = [];

  const serviceBet = service?.baseAuctionBet || 0;
  let bet = isAuctionSelected ? currentBet : serviceBet;

  // В рамках эксперимента MONEY-382 нельзя ставить меньше минимальной ставки
  if (increaseToMinimalTopBet) {
    bet = bet < minimalBet ? minimalBet : bet;
  }

  if (placingType === EPlacingType.balance && publicationPeriod) {
    const mappedTerm = mapPublishTerm(publicationPeriod);

    terms.push(mappedTerm);
  }

  if (placingType === EPlacingType.package && servicePackage) {
    const mappedTerm = mapPublishTerm(servicePackage);

    terms.push(mappedTerm);
  }

  if (bet && auction.period) {
    const mappedTerm = mapAuctionTerm({
      bet: isWithoutServices ? 0 : bet,
      period: auction.period,
      days: termsDuration,
    });

    terms.push(mappedTerm);
  }

  if (calltracking.isEnabled && calltracking.period) {
    const mappedTerm = mapCalltrackingTerm({
      period: calltracking.period,
    });

    terms.push(mappedTerm);
  }

  return terms;
}
